import React, { useState, useEffect } from 'react';
import analyticService from '../../services/analytics';

import CreateLink from './create-link';
import CreatedLinks from './created-links';

import './link-creation.scss';

function LinkCreation() {
  const [isCreateTab, setTab] = useState(true);
  const tab = isCreateTab ? <CreateLink /> : <CreatedLinks />;

  useEffect(() => {
    analyticService.trackEvent('Mobile links', 'Load', 'Link Creation');
  }, []);

  return (
    <div className="link-creation">
      {tab}
      <div className="nav">
        <div className={`links-btn ${isCreateTab ? 'selected' : ''}`} onClick={() => setTab(true)}>
          Create New Link
        </div>
        <div className={`links-btn ${isCreateTab ? '' : 'selected'}`} onClick={() => setTab(false)}>
          Links
        </div>
      </div>
    </div>
  );
}

export default LinkCreation;
